<template>
  <v-form @submit.prevent="trySendPassword" ref="form">
    <h3 class="display-1 py-8 font-weight-bold">{{ $t('forgotPassword') }}</h3>
    <v-text-field
      v-if="!sent"
      name="email"
      type="text"
      v-model="email"
      :rules="emailRules"
      :error="error"
      :error-messages="error ? errorMessage : ''"
      :label="$t('email')"
      @input="error = false"
      outlined
    ></v-text-field>
    <v-btn
      color="primary"
      v-if="!sent"
      depressed
      :disabled="!allValid"
      rounded
      large
      block
      @click="sendPassword"
    >
      {{ $t('send') }}
    </v-btn>
    <h3 class="color-primary" v-if="sent">{{ $t('forgotPasswordText') }}</h3>
    <p class="caption py-6" align="center">
      {{ $t('moveBack') }}
      <router-link
        :to="{name: 'Login', params: {defaultEmail: this.email}}"
      >{{ $t('login') }}</router-link>
    </p>
  </v-form>
</template>

<script>
import { auth } from '@/db';

export default {
  name: 'ForgotPasswordForm',
  data() {
    return {
      sent: false,
      error: false,
      errorMessage: this.$t('emailNotExist'),
      email: this.$route.params.defaultEmail,
      emailRules: [
        v => (v ? this.validEmail() : this.inValidEmail(this.$t('emailRequired'))),
        v => (/.+@.+\..+/.test(v) ? this.validEmail() : this.inValidEmail(this.$t('emailValid'))),
      ],
      mailOK: false,
    };
  },
  computed: {
    allValid() {
      return this.mailOK;
    },
  },
  methods: {
    trySendPassword() {
      // eslint-disable-next-line no-unused-expressions
      this.allValid && this.sendPassword();
    },
    sendPassword() {
      auth.sendPasswordResetEmail(this.normalize(this.email)).then(() => {
        this.sent = true;
      }).catch(() => {
        this.error = true;
      });
    },
    validEmail() {
      this.mailOK = true;
      return true;
    },
    normalize(str) {
      return str.trim().toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '');
    },

    inValidEmail(string) {
      this.mailOK = false;
      return string;
    },
  },
};
</script>

<style scoped>

</style>
